import extend from './extend';
export var Role;
(function (Role) {
    Role[Role["Expert"] = 1] = "Expert";
    Role[Role["FirmCompliance"] = 2] = "FirmCompliance";
    Role[Role["FirmAnalyst"] = 3] = "FirmAnalyst";
    Role[Role["InternalAdmin"] = 4] = "InternalAdmin";
    Role[Role["FirmTransient"] = 5] = "FirmTransient";
    Role[Role["Recruiter"] = 6] = "Recruiter";
    Role[Role["DataSteward"] = 7] = "DataSteward";
    Role[Role["InsightsChatOnly"] = 8] = "InsightsChatOnly";
})(Role || (Role = {}));
const map = new Map([
    [Role.Expert, { name: 'expert' }],
    [Role.FirmCompliance, { name: 'firm-compliance' }],
    [Role.FirmAnalyst, { name: 'firm-analyst' }],
    [Role.InternalAdmin, { name: 'internal-admin' }],
    [Role.FirmTransient, { name: 'firm-transient' }],
    [Role.Recruiter, { name: 'recruiter' }],
    [Role.DataSteward, { name: 'data-steward' }],
    [Role.InsightsChatOnly, { name: 'insights-chat-only' }],
]);
export var Seniority;
(function (Seniority) {
    Seniority[Seniority["CLevel"] = 1] = "CLevel";
    Seniority[Seniority["Executive"] = 2] = "Executive";
    Seniority[Seniority["Director"] = 3] = "Director";
    Seniority[Seniority["Manager"] = 4] = "Manager";
    Seniority[Seniority["NonManager"] = 5] = "NonManager";
    Seniority[Seniority["Other"] = 6] = "Other";
})(Seniority || (Seniority = {}));
const seniorityMap = new Map([
    [Seniority.CLevel, { name: 'C-Level' }],
    [Seniority.Executive, { name: 'Executive' }],
    [Seniority.Director, { name: 'Director' }],
    [Seniority.Manager, { name: 'Manager' }],
    [Seniority.NonManager, { name: 'Non Manager' }],
    [Seniority.Other, { name: 'Other' }],
]);
export default {
    Role: extend(map),
    Seniority: extend(seniorityMap),
};
